module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Vote"
    }
  }, [_c('div', {
    staticClass: "Vote"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名或编号",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.keyword),
      expression: "!keyword"
    }],
    attrs: {
      "src": _vm.imgPath + 'search.png'
    }
  }), _vm._v(" "), _c('van-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "clear",
    attrs: {
      "name": "clear"
    },
    on: {
      "click": _vm.clearSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.keyword),
      expression: "!keyword"
    }]
  }, [_c('div', {
    staticClass: "notice"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'notice.png',
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("本次投票有效截止时间至：" + _vm._s(_vm.end_time) + " "), (_vm.ended) ? _c('span', [_vm._v("(已结束)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "nums clearfix"
  }, [_c('div', {
    staticClass: "players fl"
  }, [_c('h4', [_vm._v(_vm._s(_vm.initData.player_num))]), _vm._v(" "), _c('p', [_vm._v("参赛选手")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets fr"
  }, [_c('h4', [_vm._v(_vm._s(_vm.initData.total_vote_num))]), _vm._v(" "), _c('p', [_vm._v("累积投票")])])]), _vm._v(" "), _c('van-tabs', {
    on: {
      "click": _vm.loadData
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部参赛"
    }
  }, [(_vm.all_player.length) ? _c('ul', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getData),
      expression: "getData"
    }],
    staticClass: "playerList clearfix",
    attrs: {
      "waterfall-disabled": "disabled",
      "waterfall-offset": "100"
    }
  }, _vm._l((_vm.all_player), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.total) + "票")])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.code))])])
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "今日最佳"
    }
  }, [_c('div', {
    staticClass: "bestBox"
  }, [_c('img', {
    staticClass: "bestImg",
    attrs: {
      "src": _vm.imgPath + 'todayBest.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "best"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("最佳选手")]), _vm._v(" "), (_vm.best_player.player_id) ? [_c('div', {
    staticClass: "user clearfix"
  }, [_c('div', {
    staticClass: "img fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.best_player.player_pic_url,
      "alt": _vm.best_player.player_name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('h4', [_vm._v(_vm._s(_vm.best_player.player_name))]), _vm._v(" "), _c('span', [_vm._v("NO." + _vm._s(_vm.best_player.player_code))])])]), _vm._v(" "), _c('p', [_vm._v("今日票数: "), _c('span', [_vm._v("+" + _vm._s(_vm.best_player.today_num))]), _vm._v(" 票"), _c('img', {
    attrs: {
      "src": _vm.imgPath + 'rise.png'
    }
  })]), _vm._v(" "), _c('p', [_vm._v("总票数: "), _c('span', [_vm._v(_vm._s(_vm.best_player.total_num))]), _vm._v(" 票")])] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])], 2), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("最佳观众")]), _vm._v(" "), (_vm.best_fanser.fans_id || _vm.best_fanser.nick) ? [_c('div', {
    staticClass: "user clearfix"
  }, [_c('div', {
    staticClass: "img fl"
  }, [_c('img', {
    attrs: {
      "src": _vm.best_fanser.header,
      "alt": _vm.best_fanser.nick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('h3', [_vm._v(_vm._s(_vm.best_fanser.nick))])])]), _vm._v(" "), _c('p', [_vm._v("赠送礼物: "), _c('span', [_vm._v("+" + _vm._s(_vm.best_fanser.gift_num))]), _vm._v(" 个")]), _vm._v(" "), (_vm.support_player.length) ? _c('p', [_vm._v("支持选手: "), _vm._l((_vm.support_player), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "head",
      attrs: {
        "src": item.player_pic_url
      }
    })
  })], 2) : _vm._e()] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])], 2)])])])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "排名"
    }
  }, [(_vm.playerList.length) ? _c('div', [_c('ul', {
    staticClass: "Ranking clearfix"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[1].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index2.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[1].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[1].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[1].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[1])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('li', {
    staticClass: "one fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[0].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index1.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[0].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[0].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[0].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[0])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])]), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "head",
    attrs: {
      "src": _vm.playerList[2].imageUrl
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "index",
    attrs: {
      "src": _vm.imgPath + 'index3.png'
    }
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.playerList[2].name))]), _vm._v(" "), _c('h4', [_vm._v("NO." + _vm._s(_vm.playerList[2].code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playerList[2].total) + "票")]), _vm._v(" "), (!_vm.ended) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.showPay(_vm.playerList[2])
      }
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn disabled"
  }, [_vm._v("投票")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getRank),
      expression: "getRank"
    }],
    staticClass: "listBox",
    attrs: {
      "waterfall-disabled": "disabled2",
      "waterfall-offset": "100"
    }
  }, [_c('ul', {
    staticClass: "list",
    attrs: {
      "id": "lists"
    }
  }, _vm._l((_vm.playerList), function(item, index) {
    return (index > 2) ? _c('li', {
      key: index,
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h4', [_c('span', [_vm._v("NO." + _vm._s(item.code))]), _c('p', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_c('p', [_vm._v("礼物数："), _c('span', [_vm._v(_vm._s(item.pay_vote_num) + " 个")])]), _vm._v(" "), _c('p', [_vm._v("总票数："), _c('span', [_vm._v(_vm._s(item.total) + " 票")])])])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]) : _vm._e()
  }), 0)])]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])]), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "活动规则"
    }
  }, [_c('div', {
    directives: [{
      name: "dompurify-html",
      rawName: "v-dompurify-html",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "rules"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.remark) + "\n\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "searched"
  }, [_c('h4', [_vm._v("搜索结果")]), _vm._v(" "), (_vm.searchList.length) ? _c('ul', {
    staticClass: "playerList clearfix"
  }, _vm._l((_vm.searchList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.total) + "票")])]), _vm._v(" "), (!_vm.ended) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.showPay(item)
        }
      }
    }, [_vm._v("投票")]) : _c('div', {
      staticClass: "btn disabled"
    }, [_vm._v("投票")])]), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.code))])])
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png',
      "alt": "暂无数据"
    }
  })])])]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "voteingBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("支持" + _vm._s(_vm.PlayerName))]), _vm._v(" "), _c('div', {
    staticClass: "voteing"
  }, [_c('ul', {
    staticClass: "ticktes"
  }, [_c('li', {
    class: {
      cur: (_vm.giftType == -1)
    },
    on: {
      "click": function($event) {
        return _vm.checkType(-1)
      }
    }
  }, [(_vm.setting.free_gift_url) ? _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.setting.free_gift_url
    }
  })]) : _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'ticket.png'
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("免费票")]), _vm._v(" "), _c('p', [_vm._v("(每天限投" + _vm._s(_vm.setting.limit) + "票)")])]), _vm._v(" "), _vm._l((_vm.gifts), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        cur: (_vm.giftType == index)
      },
      on: {
        "click": function($event) {
          return _vm.checkType(index, item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.gift_pic_url
      }
    })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(item.rate) + "票/" + _vm._s(item.price / 100) + "元)")])])
  })], 2), _vm._v(" "), (_vm.giftType != -1) ? _c('div', {
    staticClass: "count"
  }, [(_vm.giftNum > 1) ? _c('div', {
    staticClass: "cut",
    on: {
      "click": _vm.cut
    }
  }, [_vm._v("-")]) : _c('div', {
    staticClass: "cut disabled"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giftNum),
      expression: "giftNum"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.giftNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.giftNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("+")])]) : _c('div', {
    staticClass: "count"
  }), _vm._v(" "), (_vm.giftType == -1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.voteing
    }
  }, [_vm._v("投票")]) : _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("投票(" + _vm._s(_vm.price) + "元)")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335ee9f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/vote.vue
// module id = 247
// module chunks = 0